export default __webpack_public_path__ + "static/media/logo_163x63_transparente.fe7f0585.png";